import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
const router = require("app/services/router");
const Trans = require('app/components/trans/Trans')

export default class Progress extends React.Component {

	static get propTypes() {
		return {
			steps: PropTypes.arrayOf(
				PropTypes.shape({
					label: PropTypes.string.isRequired,
					time: PropTypes.any,
				})
			).isRequired,
		};
	}

	static get defaultProps() {
		return {
			steps: [],
			distributor: null,
		};
	}

	get steps() {
		return this.props.steps;
	}

	renderStep = (step, index) => {
		const active = (step.time && moment(step.time).isValid());
		const time = active ?
			moment(step.time).format('DD/MM - HH:mm') :
			'-';

		const className = [
				'order-status-box',
				active ? 'active' : null,
			]
			.filter(el => typeof el === 'string' && el.length > 0)
			.join(' ');

		const icon = active ?
			"checkmark-circle" :
			"information-circle";

		const path = router.url(`img/backend/icons/${icon}.svg`);

      if(step.label ===  translate('Returneret')) {
			return this.renderReturnedStep(step, index, className, path, time);
		}

		return (
			<div key={index} className={className} >
				<div className="icon">
					<img src={path} alt={'icon'}/>
				</div>
				<div className="text">
					<p>{step.label}</p>
					<span>{time}</span>
				</div>
			</div>
		);
	}

	renderReturnedStep(step, index, className, path, time) {
		const { distributor } = this.props;

    if (!distributor || time === '-') {
      return null
    }

		return (
			<div key={index} className={className} >
				<div className="icon">
					<img src={path} alt={'icon'}/>
				</div>
				<div className="text">
					<p>{step.label}</p>
					<span>{distributor.name}</span>
					<span>{distributor.address}</span>
					<span>{distributor.zip} {distributor.city}</span>
					<span>TLF: {distributor.phone}</span>
					<span>-</span>
					<span>{time}</span>
				</div>
			</div>
		);
	}

	renderSteps() {
		return this.steps.map(this.renderStep);
	}

	render() {
		return (
			<div className="order-status">
				<div className="line"></div>
				<div className="order-status-inner">
					{this.renderSteps()}
				</div>
			</div>
		);
	}
}
